import React from "react";
import SaitButton from "../atomic/SaitButton";
import { ColumnsPanelTrigger } from "@mui/x-data-grid";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import i18next from "../localization/i18n";

export default function GridToolbarColumnsButton(props) {
	return <ColumnsPanelTrigger render={<SaitButton text={i18next.t("columns")} variant="text" startIcon={<ViewColumnIcon />} />} />;
}
